var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DashbordSummaryLayout"},[_c('div',{staticClass:"DashbordSummaryLayout__container"},[_vm._t("connections"),_vm._t("agents")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }